import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api/endpoints';
import type { DatasetExportRequest } from '@/features/datasets/types/query.types';

export const useDatasetExport = (datasetId: string) => {
  return useMutation({
    mutationFn: async (request: DatasetExportRequest) => {
      // Returns the raw axios response so the caller can read the
      // Content-Disposition filename and the Blob body.
      return api.datasets.export(datasetId, request);
    },
  });
};
